import controller from './mail-form-input.controller';
import template from './mail-form-input.html';
import './mail-form-input.run';
import './mail-form-input.scss';

export default {
	template,
	bindings: {
		data:     '<ngModel',
		onSelect: '&?onSelect',
		options:  '<?',
		type:     '<?',
		required: '<?ngRequired',
	},
	controller,
	require:  {
		form:        '^^?mailFormHeader',
		ngModelCtrl: '?ngModel',
	},
};
